// extracted by mini-css-extract-plugin
export default {"itemContainer":"CategorySelectorItem_itemContainer__910+C","titleContainer":"CategorySelectorItem_titleContainer__40exW","title":"CategorySelectorItem_title__aMv+U"};